import { createSlice } from '@reduxjs/toolkit';

export const adminSlice = createSlice({
  name: 'admin',
  initialState: {
    stats: null, licenses: [], coupons: [], pricing: [], locations: [],
    usersList: [], deletedList: [], userDetails: null,
    loading: false, detailsLoading: false, error: null,
  },
  reducers: {
    // --- FETCH TRIGGERS ---
    fetchOverviewRequest: (state) => { state.loading = true; },
    fetchOverviewSuccess: (state, action) => { state.loading = false; Object.assign(state, action.payload); },
    fetchUsersRequest: (state) => { state.loading = true; },
    fetchUsersSuccess: (state, action) => { state.loading = false; state.usersList = action.payload; },
    fetchDeletedRequest: (state) => { state.loading = true; },
    fetchDeletedSuccess: (state, action) => { state.loading = false; state.deletedList = action.payload; },
    fetchUserDetailsRequest: (state) => { state.detailsLoading = true; },
    fetchUserDetailsSuccess: (state, action) => { state.detailsLoading = false; state.userDetails = action.payload; },
    
    // --- CRUD ACTION TRIGGERS ---
    adminActionRequest: (state) => { state.loading = true; }, // Generic loading state for crud
    adminActionSuccess: (state) => { state.loading = false; },
  }
});

export const { 
    fetchOverviewRequest, fetchOverviewSuccess, fetchUsersRequest, fetchUsersSuccess, 
    fetchDeletedRequest, fetchDeletedSuccess, fetchUserDetailsRequest, fetchUserDetailsSuccess,
    adminActionRequest, adminActionSuccess
} = adminSlice.actions;

export default adminSlice.reducer;